import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { BidStatus } from '../enums/bid-status.enum';
import { FleetClassification } from '@shared-features/enums/fleet-classification.enum';

export class Bid extends Model {
  @Expose()
  id: number;
  @Expose()
  bidPrice: number;
  @Expose()
  customerPrice: number;
  @Expose()
  status: BidStatus;
  @Expose()
  createdAt: string;
  @Expose()
  fleet: {
    id: number;
    name: string;
    shipmentCount: number;
    isVerified: boolean;
    classification: FleetClassification;
  } | null;

  @Expose()
  driver: {
    id: number;
    owner: string;
    shipmentCount: number;
    isVerifiedByElm: boolean;
  } | null;

  /**
   * Firestore doc id of the customer's chat with this bidder, once the first message opened it
   * (#47189). Present → the thread reads its messages from Firestore; absent → an empty new chat.
   * Null once a closed one is cleaned up from Firestore (backend handoff "Bid negotiation").
   */
  @Expose()
  firestoreConversationId?: string | null;
}

export class BidsData extends Model {
  @Expose()
  totalBids: number;
  @Expose()
  lowestBid: number | null;
  @Expose()
  highestBid: number | null;
  @Expose()
  @Type(() => Bid)
  bids: Bid[];
}
